import AvatarGroupComponent from './AvatarGroup.component';

export * from './AvatarGroup.component';
export default AvatarGroupComponent;
